import React from "react";
import { Container, Col, Row, Card, Button } from "react-bootstrap";
import moment from "moment";
import web3 from "../Service/web3";
const ResultCard = ({ item }) => {
  return (
    <div>
      <div className="result-item">
        <div className="result-item-header d-flex align-items-center justify-content-between">
          <p>Lotttery {item.lotteryId}</p>
          <p>Draw on {moment.unix(item.drawTime).format("DD/MM/YYYY hh:mma")} </p>
        </div>
        <div className="result-item-body">
          <div className="winner-num winner-text">
            <span className="textofresult">
              Winner <br/> {item && item.lotteryWinner}
            </span>
          </div>
          <div className="next-jack-amount"></div>
        </div>
      </div>
    </div>
  );
};
export default ResultCard;
